import { jsx as _jsx } from "react/jsx-runtime";
export const PageWrapper = ({ children, className }) => {
    return (_jsx("section", { className: `flex flex-col p-6 relative overflow-auto flex-1 h-full ${className || ''}`, children: children }));
};
